import React from "react";
import { TextField } from "@mui/material";

const DescriptionFilter = ({
  description,
  setDescription,
  title = "Project Description"
}: {
  description: string;
  setDescription: (newState: string) => void;
  title?: string;
}) => {
  return (
    <div className="component set_border_2_grey">
      <div className="title" style={{ cursor: "default", marginBottom: "10px" }}>
        <p>
          {title}&nbsp;
          {description.length > 0 && (
            <span className="ml_3" style={{ color: "#007bff", fontWeight: 500 }}>
              ({description.length} characters)
            </span>
          )}
        </p>
      </div>
      <div className="description-textarea-container">
        <TextField
          placeholder="Describe the project goal, required tasks, and expected outcomes..."
          multiline
          rows={6}
          maxRows={8}
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          variant="outlined"
          fullWidth
          size="small"
          style={{ 
            backgroundColor: "white",
            width: "100%"
          }}
          InputProps={{
            style: {
              fontSize: "12px",
              lineHeight: "1.4",
              padding: "8px 12px"
            }
          }}
        />
      </div>
    </div>
  );
};

export default DescriptionFilter; 